import Client from './KomodoClient';
import { PAGE_ALL, pagerRows } from './Resource';

// komodo Shopify connector (Komodo.SCM.Web/Controllers/Api/Shopify/*). Envelope {code,message,data}.
const enc = encodeURIComponent;

const instances = () => Client.get('/api/shopify-instance');
const createInstance = (dto) => Client.post('/api/shopify-instance', dto);
const updateInstance = (code, dto) =>
	Client.put(`/api/shopify-instance/${enc(code)}`, dto);

const webhooks = (code) => Client.get(`/api/shopify-webhook/${enc(code)}`);
// → BooleanResult { result, message }
const registerWebhooks = (code) =>
	Client.post(`/api/shopify-webhook/register/${enc(code)}`);

// Live Shopify locations merged with the local mapping rows.
const locations = (code) => Client.get(`/api/shopify-location/${enc(code)}`);
const saveLocation = (dto) => Client.post('/api/shopify-location', dto);

const shippingMethods = (code) =>
	Client.get(`/api/shopify-shipping-method/${enc(code)}`);
const saveShippingMethod = (dto) =>
	Client.post('/api/shopify-shipping-method', dto);

// ShopifyProductMappingQuery → PagerRecord<ShopifyProductMappingDTO>
const productMappings = (query) =>
	Client.post('/api/shopify-product/mapping/query-pager', {
		...PAGE_ALL,
		...(query || {}),
	}).then(pagerRows);
export const PRODUCT_ACTIONS = {
	publish: 'publish-products',
	unpublish: 'unpublish-products',
	update: 'update-products',
	updateStock: 'update-stocks',
	removeRelate: 'remove-products-relate',
	remove: 'remove-products',
};
// ChangeShopifyProductsRequest { mappingIDs: string[], executeImmediately }
const productAction = (action, mappingIDs, executeImmediately) =>
	Client.post(`/api/shopify-product/${PRODUCT_ACTIONS[action]}`, {
		mappingIDs: (mappingIDs || []).map(String),
		executeImmediately: !!executeImmediately,
	});
// AddProductToShopifyRequest { instanceCodes, materialCodes, executeImmediately }
const addProducts = (req) =>
	Client.post('/api/shopify-product/add-products', req);

// Pull*Request { instanceCode, updatedAtMin, updatedAtMax, ids, overrideExist } → queued count
const PULL_RESOURCES = {
	products: 'shopify-product',
	orders: 'shopify-order',
	customers: 'shopify-customer',
};
const pull = (kind, req) =>
	Client.post(`/api/${PULL_RESOURCES[kind]}/pull`, req);

// MessageQuery → PagerRecord<MessageRowDTO> (messageSource is forced to "Shopify" server-side)
const logs = (query) =>
	Client.post('/api/shopify-log/query-pager', {
		...PAGE_ALL,
		pageItems: 500,
		...(query || {}),
	}).then(pagerRows);

export default {
	instances,
	createInstance,
	updateInstance,
	webhooks,
	registerWebhooks,
	locations,
	saveLocation,
	shippingMethods,
	saveShippingMethod,
	productMappings,
	productAction,
	addProducts,
	pull,
	logs,
	PRODUCT_ACTIONS,
};
